const api = require('contentful');

const config = { 
    space: '3qrp1fx6a6sd', 
    accessToken: process.env.VUE_APP_CONTENTFUL_TMI_API_KEY, 
    environment: process.env.VUE_APP_BRANCH_KEY
}

const contentful = api.createClient(config)

export default {
    getArticles(author) {
        return Promise.all([
            contentful.getEntries({
                content_type: 'articles',
                order: '-fields.publishedDate',
                limit: 8,
                include: 1,
                'fields.author.sys.contentType.sys.id': 'authors',
                'fields.author.fields.name': author,
                'fields.categories[exists]': true,
            }),
        ]).then(([value]) => {
            return value;
        }).catch((err) => console.log(err));
    },
}

